import { render, staticRenderFns } from "./FilesRequirementSummary.vue?vue&type=template&id=3883a41f"
import script from "./FilesRequirementSummary.vue?vue&type=script&lang=ts"
export * from "./FilesRequirementSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports